// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import InternalTooltip_DO_NOT_USE, { TooltipProps } from '../components/tooltip/index.js';

export type InternalTooltipProps = TooltipProps;
export default InternalTooltip_DO_NOT_USE;
